import React from 'react';
import { SimpleTabs } from 'components';
import { systemItemStyles, Domains, GoalSections, ClinicalSetupSettings } from '../../fragments/system/core';
import { Images, OrgIntegrations, PermissionList, RolePermission } from 'utils';

export const ClinicalSettings = ({}) => {
    const classes = systemItemStyles();
    const { cSession } = OrgIntegrations();

    const tabsLabels = [
        cSession &&
        RolePermission([PermissionList.DOMAIN_CREATE?.code, PermissionList.DOMAIN_READ?.code]) && {
            label: 'Domains',
        },
        cSession &&
        {
            label: 'Goal Sections',
        },
        cSession && {
            label: 'Setup',
        },
    ];

    const tabsContent = [
        cSession &&
        RolePermission([PermissionList.DOMAIN_CREATE?.code, PermissionList.DOMAIN_READ?.code]) && {
            tabComponent: <Domains />,
            tab: 'Domains',
        },
        cSession && {
            tabComponent: <GoalSections />,
            tab: 'Goal Sections',
        },
        cSession && {
            tabComponent: <ClinicalSetupSettings />,
            tab: 'Setup',
        },
    ];

    const currentTab = tabsContent && tabsContent?.find((i) => i?.tab);

    return (
        <>
            <div className={classes.systemItemWrapper}>
                <div className={classes.spaceBottom}>
                    <div className={classes.systemHeaderStyles}>
                        <img
                            style={{filter: 'brightness(0) saturate(100%) invert(52%) sepia(24%) saturate(1776%) hue-rotate(216deg) brightness(99%) contrast(88%)'}}
                            src={Images.systemIcon}
                            alt="clinical"
                            className={classes.systemIcon}
                        />
                        <p className={classes.systemTitle}>Clinical Settings</p>
                    </div>
                </div>
                <SimpleTabs
                    defaultTab={currentTab?.tab || 'Domains'}
                    tabsLabels={tabsLabels}
                    tabsContent={tabsContent}
                />
            </div>
        </>
    );
};
